import { makeStyles } from "@mui/styles";

const useStyles = makeStyles(() => ({
  link: {
    textDecoration: "none",
    color: "white",
    height: "48px",
    cursor: "pointer",
    width: "100%",
  },
  linkItem: {
    color: "white",
    height: "48px",
    clipPath: "polygon(0 0, 94% 0, 100% 100%, 0% 100%)",
    cursor: "pointer",
    width: "100%",
  },
  emptyBox: {
    minWidth: "20px",
    maxWidth: "20px",
  },
  buttonBase: {
    textDecoration: "none",
    color: "white",
    cursor: "pointer",
  },
}));

export default useStyles;
